import React from 'react';
import { actionType, createAction } from './actions';

export default function useAuth() {
  const [state, dispatch] = React.useReducer(
    (state: any, action: actionType) => {
      switch (action.type) {
        case 'SET_USER':
          return {
            ...state,
            user: { ...state.user, ...action.payload },
          };
        default:
          return state;
      }
    },
    {
      user: {},
    }
  );

  const authUserDispatch = React.useMemo(
    () => ({
      setUser: (user: { users: any }) => {
        dispatch(createAction('SET_USER', user));
      },
    }),
    []
  );

  return {
    ...authUserDispatch,
    ...state,
  };
}
